export class DtoDelegacion {
    Codigo: string = '';
    Nombre: string = '';
}